import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex justify-center" }
const _hoisted_2 = { class: "w-screen lg:w-2/3" }
const _hoisted_3 = { class: "m-4" }
const _hoisted_4 = {
  key: 0,
  class: "m-4 w-full border-2"
}
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = { class: "m-4" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "m-4" }
const _hoisted_10 = { class: "flex justify-center" }
const _hoisted_11 = { class: "tw_main" }
const _hoisted_12 = { class: "m-2 flex justify-end items-center" }
const _hoisted_13 = { class: "font-bold" }
const _hoisted_14 = {
  key: 0,
  class: "ml-2"
}
const _hoisted_15 = { class: "ml-2 text-xs" }

import moment from "moment";
import * as Vue from "vue";
import { useRoute, useRouter } from "vue-router";
import { useDark, useToggle } from "@vueuse/core";
// import { Icon } from "@iconify/vue";
import { VERSION, BUILD_DATE } from "@/ver";
// import im2 from "@/components/Img2.vue";
import * as Helper from "@/helper";
import * as Types from "@/types";
// import { Adsense } from "vue3-google-adsense";
// Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyCrorCbEm5BxHLWA9pECPksltxKoqULP50",
//   authDomain: "homminer-3ccbc.firebaseapp.com",
//   projectId: "homminer-3ccbc",
//   storageBucket: "homminer-3ccbc.firebasestorage.app",
//   messagingSenderId: "744597188257",
//   appId: "1:744597188257:web:4d034ca5daa3e83dd70ae0",
//   measurementId: "G-88B3YS45QB",
// };

// Initialize Firebase
// const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);

const title = "비트코인 채굴기 성능 비교";

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

// App.vue
// import { motion } from "motion-v";
const route = useRoute();
const router = useRouter();

const is_dev = Helper.is_dev();
const URL_HEAD = Types.get_url_head();

const is_dark = useDark();
const toggle_dark = useToggle(is_dark);

const page = Vue.ref<any>({
  //
});

// 로그 끄기기
if (is_dev == false) {
  console.log = () => {};
}

Vue.onMounted(async () => {
  document.title = title;

  try {
    const url = URL_HEAD + "/bitaxe/first";
    const res = await Helper.web_get(url);
    console.log("res", res.data);
    if (res.data.code != 200) {
      throw new Error("first fail");
    }

    const ver = Number(res.data.ver);

    console.log(`ver, ${VERSION} -> ${ver}`);
    if (VERSION < ver) {
      // 업데이트 해야한다.
      page.value.need_update = true;
      page.value.need_update_msg = `v${VERSION} 👉️ v${ver}`;
    }
  } catch (err) {
    const e = err as Error;
    console.log("req err first", e.message);
  }
});

function onToggleDark() {
  toggle_dark();
}

// 새로고침
function onReload() {
  window.location.reload();
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_unref(page).need_update)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createTextVNode(" 홈페이지 내용 업데이트 필요합니다. " + _toDisplayString(_unref(page).need_update_msg) + " ", 1),
              _createElementVNode("button", { onClick: onReload }, "새로고침")
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_unref(is_dark))
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("button", { onClick: onToggleDark }, "☀️")
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("button", { onClick: onToggleDark }, "🌙")
                ]))
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/')))
            }, "홈")
          ])
        ]),
        _createElementVNode("h1", null, _toDisplayString(title)),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("main", null, [
              _createVNode(_component_router_view)
            ])
          ])
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "mt-4" }, [
          _createTextVNode(" 카카오 오픈 채팅방) - "),
          _createElementVNode("a", { href: "https://open.kakao.com/o/gqxgklph" }, "링크")
        ], -1)),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, "v" + _toDisplayString(_unref(VERSION)), 1),
          (_unref(is_dev))
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, "DEV"))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_15, "(" + _toDisplayString(_unref(moment)(_unref(BUILD_DATE)).fromNow()) + ")", 1),
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "ml-2 h-6 items-end" }, [
            _createElementVNode("iframe", { src: "https://myhits.vercel.app/api/hit/https%3A%2F%2Fbitaxe.sidnft.com?color=blue&label=hits&size=small&base_count=1" })
          ], -1))
        ])
      ])
    ])
  ]))
}
}

})